<div class="report-body">
  <div class="job-info-block jobs">
    <div class="job-info-title">
      Job Breakout
    </div>
    <div class="job-info-jobs">
      <ng-container *ngFor="let job of reportCard.totalByProject">
        <div class="job-info-job"
             *ngIf="job.name !== 'PAID_BREAK' && job.name !== 'SICK_HOURS' && job.name !== 'UNPAID_BREAK' && job.name !== 'VACATION'">
          <div class="job-info-job-name">
            {{job.name}}:
          </div>
          <div class="job-info-job-time">
            {{(job.total / 60) | number:'1.2-2'}} hrs
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="job-info-block ots">
    <div class="job-info-title">
      Overtime Details
    </div>
    <div class="job-info-jobs">
      <ng-container *ngFor="let overtime of overtimes">
        <div class="job-info-job">
          <div class="job-info-job-name">
            Week of {{overtime.name}}:
          </div>
          <div class="job-info-job-time">
            {{(overtime.total / 60) | number:'1.2-2'}} hrs OT
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="job-info-block hstr">
    <div class="job-info-title">
      Changes History
    </div>
    <div class="job-info-jobs">
      <ng-container *ngFor="let edition of editions">
        <div class="job-info-job">
          <div class="job-info-job-name">
            {{edition.title}}
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="job-info-block hstr outside-shop">
    <div class="job-info-title">
      Outside Shop
    </div>
    <div class="job-info-jobs">
      <div class="job-info-job" *ngIf="payPeriod.clockInsOutsideShop > 0">
        <div class="job-info-job-name">
          Clock-Ins:
        </div>
        <div class="job-info-job-time">
          {{payPeriod.clockInsOutsideShop}}
        </div>
      </div>
      <div class="job-info-job" *ngIf="payPeriod.clockOutsOutsideShop > 0">
        <div class="job-info-job-name">
          Clock-Outs:
        </div>
        <div class="job-info-job-time">
          {{payPeriod.clockOutsOutsideShop}}
        </div>
      </div>
    </div>
  </div>
</div>
